<template>
    <div ref="editor" class="root"></div>
</template>

<script>
import JSONEditor from 'jsoneditor'

export default {
  name: 'jsonEditor',
  props: {
    data: { required: true },
    expandAll: Boolean,
    onMount: { type: Function, default: () => {}},
    mode: {type: String, default: 'tree'},
  },
  data () {
    return {
      editor: null
    }
  },
  mounted () {
    this.editor = new JSONEditor(this.$refs.editor, {})
    this.setJSON()
    this.onMount(this.editor)
  },
  updated () {
    this.setJSON()
  },
  watch: {
    mode(val) {
      try {
        this.editor.setMode(val)
      } catch (e) {
        this.editor.set(this.data || {})
        this.editor.setMode(val)
      }
      if (val === 'tree' && this.expandAll) this.editor.expandAll()
    }
  },
  methods: {
    setJSON () {
      this.editor.set(this.data || {})
      if (this.expandAll) this.editor.expandAll()
    }
  }
}
</script>

<style scoped>
    .root {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/jsonEditor.vue